/**
 * Nombres legibles de los campos que validan los stores de cotización y orden de producción.
 * Compartido para que ambos módulos le hablen igual al usuario. Los campos que no figuren
 * acá se muestran con su nombre técnico, que es mejor que no decir nada.
 */
export const ETIQUETAS_CAMPOS = {
  Cliente: 'Cliente',
  ClienteDescripcion: 'Cliente',
  CodigoCliente: 'Cliente',
  Referencia: 'Referencia',
  CodigoMoneda: 'Moneda',
  CodigoUnidadVenta: 'Unidad de venta',
  TasaDolarCompra: 'Tasa dólar compra',
  TasaDolarVenta: 'Tasa dólar venta',
  FamiliaMaterial: 'Familia de material',
  MedidaEje: 'Medida eje',
  MedidaDesarrollo: 'Medida desarrollo',
  AnchoMaterial: 'Ancho del material',
  MargenSuperior: 'Margen superior',
  CantidadEtiquetas: 'Cantidad de etiquetas',
  EtiquetasEje: 'Etiquetas eje',
  EtiquetasDesarrollo: 'Etiquetas desarrollo',
  GapEje: 'Gap eje',
  GapDesarrollo: 'Gap desarrollo',
  AltoTotal: 'Alto total',
  OrdenProduccionCantidad: 'Cantidades',
  SolicitudCantidad: 'Cantidades',
  // Extrusión
  MaterialResultante: 'Material resultante',
  BobinasExtrusion: 'Bobinas del proceso de extrusión',
  EspesorResultante: 'Espesor (μm)',
  DensidadResultante: 'Densidad (g/cm³)',
  GramajeResultante: 'Gramaje (g/m²)',
};

/**
 * Mensaje de la notificación de validación: enumera qué falta completar.
 *
 * @param {string[]} campos claves de los campos inválidos
 * @returns {string}
 */
export function describirCamposInvalidos(campos) {
  if (!campos?.length) return 'Completar los campos obligatorios del formulario';

  const nombres = [...new Set(campos.map((campo) => ETIQUETAS_CAMPOS[campo] ?? campo))];
  return `Completar los campos obligatorios: ${nombres.join(', ')}`;
}
